export { GetVariableNameArgs } from './get-variable-name-args';
